import { BarChart } from "@mui/x-charts/BarChart";
import { createTheme, ThemeProvider } from "@mui/material";
import { useEffect, useState } from "react";
import { filters, newsTypes } from "../../constants/Dashboard";
import { eachDayOfInterval, format, parseISO } from "date-fns";

const TickPlacementBars: React.FC<{ newsData, selectedFilter }> = ({ newsData, selectedFilter }) => {
  const [chartData, setChartData] = useState([]);
  const newTheme = createTheme({ palette: { mode: "dark" } });
  const processData = () => {
    const counts = {};

    newsData?.forEach((news) => {
      const date = news.time ? news.time.split(" ")[0] : "null"; // Extract the date part
      if (!counts[date]) {
        // Initialize counts for all news types dynamically
        counts[date] = { time: date };
        newsTypes.forEach((newsType) => {
            counts[date][newsType.name] = 0;
        });
      }
      if (counts[date][news.dataSource] !== undefined) {
        counts[date][news.dataSource] += 1;
      }
    });

    const processedData = Object.values(counts);
    setChartData(fillMissingDates(processedData));
  };
  const fillMissingDates = (processedData) => {
    if (processedData.length === 0) return [];
  
    const dates = processedData.map((item) => parseISO(item.time));
    const allDates = eachDayOfInterval({
      start: selectedFilter? filters.find((x) => x.value === selectedFilter).func : dates.reverse().find(obj => !isNaN(obj)),
      end: new Date(),
    })
  
    const filledData = allDates.map((date) => {
      const dateString = format(date, "yyyy-MM-dd");
      const existing = processedData.find((item) => item.time === dateString);
      if (existing) return existing;
  
      // Create a new entry for missing dates
      const emptyEntry = { time: dateString };
      newsTypes.forEach(({ name }) => {
        emptyEntry[name] = 0;
      });
      return emptyEntry;
    });
  
    return filledData;
  };
  const addLabels = () => {
    return newsTypes.map((type) => ({
      stack: "data",
      label: type.name,
      dataKey: type.name
    }));
  }
  useEffect(() => {
    processData();
  }, [newsData]);

  return (
    <ThemeProvider theme={newTheme}>
      <div style={{ width: "60%" }}>
        <BarChart
          dataset={chartData}
          xAxis={[
            {
              scaleType: "band",
              dataKey: "time",
              tickPlacement: "middle",
              tickLabelPlacement: "middle",
              
            },
          ]}
          series={addLabels()}
        />
      </div>
    </ThemeProvider>
  );
};

export default TickPlacementBars;
